import * as React from 'react';
import './ExtraLarge.less';

interface IExtraLargePropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class ExtraLarge extends React.Component<IExtraLargePropType, any> {
    static defaultProps = {
        prefixCls: 'extraLarge',
    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                }}>
                    <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                </div>
            </div>
        );
    }
}

export default ExtraLarge;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/extraLarge/ExtraLarge.tsx